// extracted by mini-css-extract-plugin
export default {"imageWrapper":"dG-z","twoColumnImage":"eG-z"};